module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAATlBMVEUAAAAAAAAAVaoASbYAVcYLZLwQY8UPZMEQZb8QZL8QYsASZcITZMATY8ASY8ASZb8TZMATZL8UZMATZMATZcATZMATZL8TZL8TZMATZL/6nwdXAAAAGnRSTlMAAQYHCRcfITBAQVNpan6YnqSpxc3T2ODn6LRoq5oAAAA0SURBVAjXY2BAAWLccCaHOB8jjM0qLMQCYzMLijBBmeyi/FAlXBK8UDEeSU6YSgE2BjQAAEeIAUfmYz6GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/toRight1.png
// module id = A3H0
// module chunks = 1